module.exports = __webpack_public_path__ + "static/media/HRog.babe3974.svg";